type Props = {
    children: any
}

const ModalBody = (props: Props) => {
    return (
        <div className="modal-body pl-5 pr-5">
            {props.children}
        </div>
    );
};

export default ModalBody;
